import Banner from './banner';
import React from 'react';

export default function BannerLoader(props) {
  return <Banner { ...props } />;
}
